"use client";

import React, { useEffect, useRef, useState } from "react";
import CountUp from "react-countup";
import { Heading, Text } from "ui-components";

import TrustpilotWidget from "@/components/TrustpilotWidget/TrustpilotWidget";

const results = [
  {
    title: 500000,
    text: "Job applications per month",
    plusSign: true,
  },
  {
    title: 1000000,
    text: "Users per month",
    plusSign: true,
  },
  {
    title: 450,
    text: "Inclusive Employers",
    plusSign: true,
  },
];

export default function JobApplicationsUsersEmployers(): JSX.Element {
  const [countStart, setCountStart] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry?.isIntersecting) {
          setCountStart(true);
          observer.disconnect();
        }
      },
      { threshold: 0.5 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const formatNumber = (num: number): string => {
    if (num >= 1000000) {
      return `${(num / 1000000).toFixed(1).replace(".0", "")}M`;
    }
    if (num >= 1000) {
      return `${(num / 1000).toFixed(1).replace(".0", "")}K`;
    }
    return num.toString();
  };

  return (
    <div ref={sectionRef} className="w-full mx-auto">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 items-center w-full">
        {/* Trustpilot Widget */}
        <div className="flex justify-center items-center">
          <div className="trust-pilot w-full max-w-[400px]">
            <TrustpilotWidget />
          </div>
        </div>

        {/* Stats items */}
        {results.map((row) => (
          <div
            key={row.text}
            className="flex flex-col gap-y-4 px-2.5 my-5 items-center text-center"
          >
            <Heading
              className="block !text-3xl font-extrabold"
              variant="h2"
              intent="blue"
              align="center"
            >
              <CountUp
                start={countStart ? 0 : row.title}
                end={row.title}
                duration={3}
                formattingFn={formatNumber}
              />
              {row.plusSign && "+"}
            </Heading>
            <Text className="!text-[20px] font-normal" align="center">
              {row.text}
            </Text>
          </div>
        ))}
      </div>
    </div>
  );
}
